import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { assignRecursive } from "../../utils";
import initialState from "../initial-state";

export type Theme = {
  colors?: { [k: string]: string };
} | null;

const theme = createSlice({
  name: "theme",
  initialState: initialState.theme,
  reducers: {
    setTheme(state, action: PayloadAction<Theme>) {
      if (!action) return state;

      return assignRecursive(state, action.payload);
    },
  },
});

export const { setTheme } = theme.actions;

export default theme;
